import React from 'react'
import { useSelector } from 'react-redux'
import LogoPopoverItem from './LogoPopoverItem'
import Popover from '../Popover'
import { t } from '../../utils/i18n'
import { formatCurrency } from '../../utils/money'
import { isCargo } from '../../utils/url'
import {
  getLogoPrice,
  getBaseModel,
  getComponent,
  getOption
} from '../../utils/bike-schema'
import { BikeAngle, Component, Option, State } from 'shared'

interface LogoOption {
  component: Component | undefined
  option: Option
  logoUrl?: string
  angle: BikeAngle
}

const LogoPopover: React.FC = () => {
  const currencyCode = useSelector((state: State) => state.currencyCode)
  const bikeConfig = useSelector((state: State) => state.bikeConfig)
  const lang = useSelector((state: State) => state.lang)

  const price = getLogoPrice(currencyCode)
  const baseModel = getBaseModel(bikeConfig.baseModelId)

  const logoOptions: LogoOption[] = bikeConfig.choices.reduce<LogoOption[]>(
    (
      memo,
      { componentId, optionId, logo, logo_right, logo_left, logo_front }
    ) => {
      const component = getComponent(baseModel, componentId)
      const option = getOption(component, optionId)
      if (option?.logo_placement) {
        memo.push({
          component,
          option,
          logoUrl: logo,
          angle: 'none'
        })
      }
      if (option?.logo_placement_right) {
        memo.push({
          component,
          option,
          logoUrl: logo_right,
          angle: 'right'
        })
      }
      if (option?.logo_placement_left) {
        memo.push({
          component,
          option,
          logoUrl: logo_left,
          angle: 'left'
        })
      }
      if (option?.logo_placement_front) {
        memo.push({
          component,
          option,
          logoUrl: logo_front,
          angle: 'front'
        })
      }
      return memo
    },
    []
  )

  const label = isCargo ? t('logo_price') : t('logo_price_adplate')

  return (
    <Popover width={300} alignTo=".velorbis-customizer-logo-component">
      <div className="velorbis-customizer-popover-header">{t('logo')}</div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-scroll velorbis-customizer-space-dist-v">
        <div className="velorbis-customizer-popover-body-logo">
          {logoOptions.length > 0 ? (
            logoOptions.map((item, i) => (
              <LogoPopoverItem key={i} lang={lang} item={item} />
            ))
          ) : (
            <div className="velorbis-customizer-text">
              {t('logo_no_options')}
            </div>
          )}
        </div>
        <div className="velorbis-customizer-form-control">
          <label>{label}</label>
          <div>{formatCurrency(price, currencyCode)}</div>
        </div>
      </div>
    </Popover>
  )
}

export default LogoPopover
